export const filterByQuery = (
  stringQuery: any,
  searchQuery: string
): boolean => {
  if (
    //will evaluate to true if value is not: null, undefined, NaN, empty string (""), 0, false
    stringQuery &&
    //if there are same characters in first and second parameters (stringQuery and searchQuery)
    stringQuery.toLowerCase().includes(searchQuery.toLowerCase())
  ) {
    //return true if check is passed
    return true;
  }
  //if check is not passed, then just return false
  return false;
};
